import { render, staticRenderFns } from "./lei-informatica.vue?vue&type=template&id=5b3a8861&scoped=true&"
import script from "./lei-informatica.vue?vue&type=script&lang=js&"
export * from "./lei-informatica.vue?vue&type=script&lang=js&"
import style0 from "./lei-informatica.vue?vue&type=style&index=0&id=5b3a8861&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3a8861",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VIcon,VRadio,VRadioGroup,VSpacer})
